import { Inject, Injectable } from '@angular/core';
import { RequestParams } from '../types/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiUrl } from './constants';
import { HttpErrorResponse } from '@angular/common/http';
import { RoutesEnum } from '@src/app/enums';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  exchangeType: number = 1;
  currencyFrom!: string;
  currencyTo!: string;

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  private rawCurrenciesSubject = new BehaviorSubject<Record<string, any>[]>([]);
  rawCurrencies$: Observable<Record<string, any>[]> =
    this.rawCurrenciesSubject.asObservable();

  private currencyRatesSubject = new BehaviorSubject<Record<string, any>[]>([]);
  currencyRates$: Observable<Record<string, any>[]> =
    this.currencyRatesSubject.asObservable();

  private cbRatesSubject = new BehaviorSubject<Record<string, any>[]>([]);
  cbRates$: Observable<Record<string, any>[]> =
    this.cbRatesSubject.asObservable();

  private exchangeRatesSubject = new BehaviorSubject<Record<string, any>>({});
  exchangeRates$: Observable<Record<string, any>> =
    this.exchangeRatesSubject.asObservable();

  constructor(
    @Inject(Router) private router: Router,
    private apiService: ApiService,
  ) {}

  get isLoading(): boolean {
    return this.isLoadingSubject.value;
  }

  get currencyRates(): Record<string, any>[] {
    return this.currencyRatesSubject.value;
  }

  get rawCurrencies(): Record<string, any>[] {
    return this.rawCurrenciesSubject.value;
  }

  get cbRates(): Record<string, any>[] {
    return this.cbRatesSubject.value;
  }

  get exchangeRates(): Record<string, any> {
    return this.exchangeRatesSubject.value;
  }

  setIsLoading(value: boolean): void {
    this.isLoadingSubject.next(value);
  }

  setRawCurrencies(data: Record<string, any>[]): void {
    this.rawCurrenciesSubject.next(data);
  }

  setCurrencyRates(data: Record<string, any>[]): void {
    this.currencyRatesSubject.next(data);
  }

  setCbRates(data: Record<string, any>[]): void {
    this.cbRatesSubject.next(data);
  }

  setExchangeRates(data: Record<string, any>): void {
    this.exchangeRatesSubject.next(data);
  }

  /**
   * @description Handling API call errors
   * @param {HttpErrorResponse} error
   */
  handleError(error: HttpErrorResponse): void {
    this.isLoadingSubject.next(false);

    if (
      error.error?.statusCode === 404 ||
      error.error?.status === 404 ||
      error?.status === 404
    ) {
      this.router.navigate(['/' + RoutesEnum.NOT_FOUND], {
        skipLocationChange: true,
      });
    } else if (error.error?.message) {
      console.error(error.error?.message);
    }
  }

  getCurrencyRates(params?: RequestParams): Observable<Record<string, any>> {
    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getCurrencyRates,
      params,
    });
  }

  getExchangeRates(params: RequestParams): Observable<Record<string, any>> {
    // this.isLoadingSubject.next(true);

    return this.apiService.request({
      method: 'get',
      endpoint: ApiUrl.getExchangeRates,
      params,
    });
  }
}
